import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh_CH';
import zhTW from './locales/zh_TW';
import enUS from './locales/en_US';

let language = window.localStorage.getItem('merchant_language') || 'eng';

const i18n = createI18n({
    legacy: false,
    locale: language,
    fallbackLocale: 'eng',
    messages: {
        chn: zhCN,
        cht: zhTW,
        eng: enUS
    }
});

export default i18n;
